<template>
	<div>
		<b-modal
			class="modalGeneric"
			ref="modalGeneric"
			:visible="modalAtivado"
			id="modalGeneric"
			@hidden="closeModal"
			hide-footer
			hide-header
		>
			<div class="d-block text-left">
				<div @click="closeModal" class="modalGeneric__close">
					<img src="~@/assets/images/icones/close.svg" alt="Fechar" />
				</div>
				<h1 class="title" v-if="content.title">{{content.title}}</h1>
				<h2 class="subtitle" v-if="content.subtitle">{{content.subtitle}}</h2>
				<p v-if="content.text">{{content.text}}</p>
        <small></small>
        <div class="button-box" v-if="content.button">
          <div class="save" v-if="content.button">
            <a class="btn" v-if="content.button.link != 'close'" :href="content.button.link" target="_self">{{content.button.text}}</a>
            <a class="btn" v-if="content.button.link == 'close'" @click="closeModal" target="_self">{{content.button.text}}</a>
          </div>
        </div>
        <small></small>
			</div>
		</b-modal>
	</div>
</template>
  
<script>
// import { mapState } from "vuex";
// import IconCheck from "@/components/icones/iconCheck.vue";

export default {
	props: [
		// "showModal",
		// "content"
	],
	computed: {
    modal() {
      return this.$store.state.interacoes.genericModal;
    },
    modalAtivado() {
      return (this.modal.modalAtivado);
    },
    content() {
      return this.modal.content;
    },
	},
	methods: {
    fecharModal() {
    },
		closeModal() {
      this.$store.commit("interacoes/SET_GENERIC_MODAL", {
        ativado: false
      });

			this.$emit("showGenericModal", false);
			this.$refs["modalGeneric"].hide();
		},
	},
};
</script>
  
<style lang="scss">
.modalGeneric {
	&__list {
		margin-top: 20px;
		li {
			position: relative;
			display: flex;
			align-items: center;
			font-size: 15px;
			line-height: 1.3;
			color: $gray;
			font-weight: 400;
			margin-bottom: 8px;
			&:last-child {
				margin-bottom: 0;
			}
		}
		svg {
			margin-right: 10px;
		}
	}
	&__close {
		cursor: pointer;
		position: absolute;
		right: -40px;
		top: -40px;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 200ms ease;
		&:hover {
			transform: scale(1.2);
		}
	}
	&__image {
		margin-top: 35px;
	}
}
#modalGeneric {
	.modal-dialog {
		@media (min-width: 576px) {
			max-width: 691px;
			margin: 1.75rem auto;
		}
	}
	.modal-body {
		padding: 0;
	}
	.modal-content {
		border: 3px solid #ff4876;
		border-radius: 10px;
		padding: 50px 50px 30px;
	}
	.modal-header {
		border-bottom: none;
	}
	.title {
		font-size: 25px;
		font-weight: 600;
		margin-top: 25px;
	}
	.subtitle {
		font-size: 16px;
		margin-top: 15px;
		font-weight: 600;
		color: $gray;
		&__logo {
			display: inline;
			color: #0a0202;
			span {
				color: #ff4876;
			}
		}
	}
	a {
		color: $gray;
		display: contents;
		text-decoration: underline;
		cursor: pointer;
		&:hover {
			color: #ff4876;
		}
	}
	p {
		margin-top: 20px;
		font-size: 17px;
		line-height: 1.3;
		color: $gray;
		font-weight: 400;
		a {
			display: block;
			margin-top: 20px;
		}
	}
	small {
		margin-top: 20px;
		font-size: 11px;
		display: inline-block;
	}
	.button-box {
		display: flex;
		align-items: center;
		justify-content: center;
		.save {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 51px;
			width: 335px;
			.btn {
				color: #ffffff;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				font-weight: bold;
				font-family: $font__main;
				text-transform: uppercase;
				text-decoration: none;
				height: 100%;
				width: 100%;
				border-radius: 5px;
				background-color: #73cb53;
				margin: 7.5px;
			}
		}
	}
}
</style>